import cn from 'classnames';

import PageHeaderWrapper from '@/creditflowresearch/ui/common/components/PageHeaderWrapper';
import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import NoAccessOverlayStats from '@/creditflowresearch/ui/components/creditFlow/common/NoAccessOverlayStats';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import StatRelatedData from './StatRelatedData';
import StatContent from './StatContent';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { useStatContext } from '@/creditflowresearch/application/ArticlesAndStats/Stat';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';

import cardStyles from '@creditflowresearch/uilib/styles/card.module.scss';
import styles from '../common/styles.module.scss';

const Stat = () => {
  const { checkAccessByUserPlan, checkAccessByFeature } = useUserPlanContext();
  const { stat: { noAccess } } = useStatContext();
  const granted = useAccessGrant();
  const checks = [
    !noAccess,
    granted || checkAccessByUserPlan(UserPlanType.PREMIUM),
    granted || checkAccessByFeature(UserPlanFeature.NewIssueStats),
  ];

  return (
    <>
      <PageHeaderWrapper title="Stats" />
      <CheckUserAccess conditions={ [{ checks, fallback: <NoAccessOverlayStats /> }] }>
        <>
          <div className={ cn(cardStyles.cardContainer, styles.creditFlowWrapper) }>
            <StatRelatedData />
            <StatContent />
          </div>
          <MissingSomethingModalButton />
        </>
      </CheckUserAccess>
    </>
  );
};

export default Stat;
